import callEndpoint, { CallEndpointOptions } from './call-endpoint';
import ApiError, { getStatusErrorMessaging } from './api-error';

interface CallVoidEndpointOptions extends Omit<CallEndpointOptions, 'throttleKey'> {
  errorOn404?: boolean;
}

export async function callVoidEndpoint({
  errorOn404 = true,
  ...props
}: CallVoidEndpointOptions): Promise<void> {
  const resp = await callEndpoint({
    ...props,
  });

  if (!resp) {
    // no error and no response means the data call was throttled
    return Promise.resolve();
  }

  if (!resp.ok && (resp.status === 413 || resp.status !== 404 || (resp.status === 404 && errorOn404))) {
    throw new ApiError(
      resp.statusText || getStatusErrorMessaging(resp.status),
      resp.status,
      undefined,
      resp.headers.get('x-correlation-id') || undefined
    );
  }

  if (resp.status === 404) {
    return Promise.resolve();
  }
}
